'use strict';

import { THEME_TYPES } from "@infoods/lifebase-ui";
import { getLoginRequiredResolveObj } from "../shared/utils/angularUtils";

export const paymentModule = angular.module(
  'app.payment',
  []
).config(paymentConfig);

paymentConfig.$inject = ['$routeProvider'];

function paymentConfig($routeProvider) {
  $routeProvider
    .when('/checkout', {
      template: '<ngz-checkout></ngz-checkout>',
      pageConfig: {
        theme: THEME_TYPES.NUTRITION,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/scan-iq-checkout', {
      template: '<ngz-checkout></ngz-checkout>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/challenge-checkout', {
      template: '<ngz-challenge-checkout></ngz-challenge-checkout>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/payment-result', {
      template: '<ngz-payment-result></ngz-payment-result>',
      pageConfig: {
        theme: THEME_TYPES.NUTRITION,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/scaniq-payment-result', {
      template: '<ngz-scan-iq-payment-result></ngz-scan-iq-payment-result>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/challenge-payment-result', {
      template: '<ngz-challenge-payment-result></ngz-challenge-payment-result>',
      pageConfig: {
        theme: THEME_TYPES.NUTRITION,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/select-subscription', {
      template: '<ngz-select-subscription></ngz-select-subscription>',
      pageConfig: {
        hideNavBar: true,
      },
    })
    .when('/detailed-revenue', {
      template: '<ngz-detailed-revenue-page></ngz-detailed-revenue-page>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/self-billing/setup-card', {
      template: '<ngz-self-billing-setup-card></ngz-self-billing-setup-card>',
      pageConfig: {
        hideNavBar: true,
      },
      resolve: {
        setupCardRequired: ['AuthService', (AuthService) => AuthService.setupCardRequired()],
      },
    })
    .when('/self-billing/failed-payment', {
      template: '<ngz-self-billing-failed-payment></ngz-self-billing-failed-payment>',
      pageConfig: {
        hideNavBar: true,
      },
      resolve: {
        failedPaymentRequired: ['AuthService', (AuthService) => AuthService.failedPaymentRequired()],
      },
    });
}
